package dev.lingvo.ops.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.navigation.Link
import dev.lingvo.ops.api.OpsApi
import dev.lingvo.ops.components.OpsPageHeader
import dev.lingvo.ops.components.OpsPanel
import dev.lingvo.ops.components.OpsResourceStates
import dev.lingvo.ops.components.OpsShell
import dev.lingvo.ops.state.rememberOpsResource
import dev.lingvo.shared.ops.OpsSearchDto
import dev.lingvo.site.ds.LBadge
import dev.lingvo.site.ds.LBadgeVariant
import dev.lingvo.site.ds.LEmptyState
import dev.lingvo.site.ds.LSearchField
import dev.lingvo.site.ds.LTable
import dev.lingvo.site.ds.LTableBody
import dev.lingvo.site.ds.LTableCell
import dev.lingvo.site.ds.LTableHead
import dev.lingvo.site.ds.LTableHeaderCell
import dev.lingvo.site.ds.LTableRow
import dev.lingvo.site.ds.Space
import dev.lingvo.site.nav.UrlState
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page("/search")
@Composable
fun SearchPage() {
    val ctx = rememberPageContext()
    var query by remember { mutableStateOf(UrlState.read(ctx, "q").orEmpty()) }
    var submitted by remember { mutableStateOf(query) }
    OpsShell("Search") {
        val resource = rememberOpsResource(submitted) { selected ->
            if (selected.isBlank()) OpsSearchDto("", emptyList(), false, emptyList(), emptyList())
            else OpsApi.search(selected)
        }
        Column(Modifier.fillMaxWidth().gap(Space.XL)) {
            OpsPageHeader("Search", "Find the person, workspace or operational record behind a support question.", resource.state.isRefreshing, resource::refresh)
            LSearchField(query, { query = it; UrlState.replace(mapOf("q" to it)) }, label = "Search the operator directory", onCommit = { submitted = query })
            OpsPanel("Jump to a record", "Searches people, workspaces, projects, jobs and billing documents. It does not search strings, keys, translations, comments or glossary terms.") {
                OpsResourceStates(resource.state, "No records", "Enter a longer string or an exact id.", "No result matches \"$submitted\".", retry = resource::refresh) { result ->
                    P { Text("${if (result.notSearched.isEmpty()) "" else "Not searched: ${result.notSearched.joinToString()}. "}${if (result.exactOnly) "Exact matching only was used for this short query." else ""}") }
                    if (result.query.isBlank()) LEmptyState("Find an operational record", "Enter a name, email, workspace slug or exact id, then press Enter.") {}
                    else if (result.hits.isEmpty()) LEmptyState("No result matches \"${result.query}\"", "Try a longer string, or an exact id.") {}
                    else LTable(caption = "Search results") {
                        LTableHead { LTableRow { listOf("Kind", "Title", "Details", "Open").forEach { LTableHeaderCell { Text(it) } } } }
                        LTableBody { result.hits.forEach { hit -> LTableRow {
                            LTableCell { LBadge(hit.kind.name, variant = LBadgeVariant.INFO) }
                            LTableCell { Text(hit.title) }
                            LTableCell { Text("${hit.subtitle} · matched on ${hit.matchedOn}") }
                            LTableCell { Link(hit.href) { Text("Open") } }
                        } } }
                    }
                }
            }
        }
    }
}
